if (!customElements.get('sticky-add-to-cart-bar')) {
  class StickyAddToCartBar extends HTMLElement {
    constructor() {
      super();
      this.originalButton = null;
      this.observer = null;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const sectionId = this.dataset.sectionId;
      
      this.originalButton = document.querySelector(`#ProductSubmitButton-${sectionId}`);
      if (!this.originalButton) return;

      this.setupObserver();
      this.setupButtonClick();
      this.setupVariantChangeListener();
    }

    setupButtonClick() {
      const stickyButton = this.querySelector('.sticky-add-to-cart-bar__button button');
      if (!stickyButton) return;

      stickyButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.originalButton.click();
      });
    }

    setupVariantChangeListener() {
      const observer = new MutationObserver(() => {
        this.updateVisibility();
      });

      observer.observe(this.originalButton, {
        attributes: true,
        attributeFilter: ['disabled']
      });
    }

    updateVisibility() {
      if (this.originalButton.disabled) {
        this.classList.remove('is-visible');
      }
    }

    setupObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.classList.remove('is-visible');
          } else {
            const buttonRect = entry.boundingClientRect;
            if (buttonRect.top < 0 && !this.originalButton.disabled) {
              this.classList.add('is-visible');
            } else {
              this.classList.remove('is-visible');
            }
          }
        });
      }, options);

      this.observer.observe(this.originalButton);
    }

    disconnectedCallback() {
      if (this.observer && this.originalButton) {
        this.observer.unobserve(this.originalButton);
      }
    }
  }

  customElements.define('sticky-add-to-cart-bar', StickyAddToCartBar);
}
